import React from 'react';
import { useReadOnly } from 'nifty-slate-react';

import DocNodeWithChooser from '../doc-node-with-chooser';
import Checkbox from '../checkbox';

const DocChecklistItem = props => {
    const { attributes, children, element, onNodeChange } = props;
    const checked = element.data && element.data.checked;
    const readOnly = useReadOnly()

    const handleMenuAction = type => {
        onNodeChange && onNodeChange(element, type);
    }

    const handleChange = checked => {
        onNodeChange && onNodeChange(element, element.type, { checked });
    }


    return (
        <DocNodeWithChooser current={element.type} element={attributes.ref.current} items={props.menuItems} depth={1} onAction={handleMenuAction}>
            <div className="doc-node doc-checklist-item" {...attributes}>
                <div
                    className="doc-checklist-item-text"
                    contentEditable={!readOnly}
                    suppressContentEditableWarning
                >
                    {children}
                </div>

                <div contentEditable={false} className="doc-checklist-item-check">
                    <Checkbox checked={checked} onChange={handleChange} disabled={readOnly} />
                </div>
            </div>
        </DocNodeWithChooser>
    )
}

export default DocChecklistItem;
